export default "__VITE_ASSET__KjrCHH_m__"